import type {FusAction, UIStat} from './statistics.types'

const SECOND = 1000
const MAX_QUEUE_LENGTH = 1000
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const defaultSendStatThrottleTime = 30 * SECOND
export const UIStatistics: UIStat = {
  send: false,
  mode: 'internal',
  interval: defaultSendStatThrottleTime,
  actionQueue: [],
}
export function addActionsToQueue(actions: ReadonlyArray<FusAction> | null | undefined) {
  if (!actions || actions.length === 0) {
    return
  }

  UIStatistics.actionQueue = UIStatistics.actionQueue.concat(actions)

  if (UIStatistics.actionQueue.length > MAX_QUEUE_LENGTH) {
    UIStatistics.actionQueue.splice(0, UIStatistics.actionQueue.length - MAX_QUEUE_LENGTH)
  }
}
export const trackCustomEvent = (fusActions: ReadonlyArray<FusAction> | null | undefined) => {
  if (!fusActions || fusActions.length === 0) {
    return
  }

  addActionsToQueue(fusActions)
}
